import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

import AlbumHighlightsItems from "./album_highlights_items";
import Loader from "../loader";
import ModalPhotoViewer from "./modal_photo_viewer";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    albumId: PropTypes.number.isRequired,
    isActive: PropTypes.bool.isRequired,
  },
  getInitialState() {
    return {
      albumPhotos: [],
      albumTitles: [],
      isModalOpen: false,
      modalPhotoIndex: 0,
      modalPhotoUrl: "",
      modalPhotoDir: "photo-w",
      modalPhotoUploadedDate: "",
      modalAlbumId: 0,
      loading: true,
      scrollPos: 0,
    };
  },
  componentDidMount() {
    this.loadAlbumDataFromServer();
  },
  loadAlbumDataFromServer() {
    $.ajax({
      url: "/api/album/get_album_highlights",
      type: "POST",
      cache: false,
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        circle_id: this.props.circleId,
      },
    })
      .done(
        function(data) {
          this.setState({
            albumPhotos: data.albumPhotos,
            albumTitles: data.albumTitles,
            loading: false,
          });
        }.bind(this)
      )
      .fail(
        function() {
          this.setState({
            loading: false,
          });
        }.bind(this)
      );
  },
  SetModalPhotoDirection(url) {
    var img = new Image();
    img.src = url;
    var width = img.width;
    var height = img.height;
    var dispAspectRatio = (window.innerWidth / window.innerHeight).toFixed(2);
    var picAspectRatio = (width / height).toFixed(2);
    var direction =
      dispAspectRatio - picAspectRatio < 0 ? "photo-w" : "photo-h";
    this.setState({
      modalPhotoDir: direction,
    });
  },
  openModal(albumId, photoIndex) {
    var scrollPos = $("body").scrollTop();
    // var marginLeft =
    //   (window.innerWidth - $("body .container").outerWidth()) / 2;
    // $('body').css({position:'fixed', marginTop:-scrollPos, marginLeft:marginLeft});
    var url = this.state.albumPhotos[albumId][photoIndex].safe_image;
    this.SetModalPhotoDirection(url);
    var uploaded_date = this.state.albumPhotos[albumId][photoIndex]
      .uploaded_date;
    this.setState({
      isModalOpen: true,
      modalPhotoIndex: photoIndex,
      modalPhotoUrl: url,
      modalPhotoUploadedDate: uploaded_date,
      modalAlbumId: albumId,
      scrollPos: scrollPos,
    });
  },
  closeModal() {
    $("body").css({ position: "relative", marginTop: "0", marginLeft: "0" });
    // $('body').scrollTop(this.state.scrollPos);
    this.setState({
      isModalOpen: false,
    });
  },
  changePhoto(e) {
    var index = e;
    var photoCount = this.state.albumPhotos[this.state.modalAlbumId].length;
    if (index < 0) {
      index = photoCount - 1;
    } else if (index > photoCount - 1) {
      index = 0;
    }
    var url = this.state.albumPhotos[this.state.modalAlbumId][index].safe_image;
    if (typeof window === "undefined") this.SetModalPhotoDirection(url);
    var uploaded_date = this.state.albumPhotos[this.state.modalAlbumId][index]
      .uploaded_date;
    this.setState({
      modalPhotoIndex: index,
      modalPhotoUrl: url,
      modalPhotoUploadedDate: uploaded_date,
    });
  },
  photoClicked(albumId, photoIndex) {
    if (typeof window === "undefined") this.openModal(albumId, photoIndex);
  },
  render() {
    var albumHighlightsItems = [];
    Object.keys(this.state.albumPhotos).forEach(function(key) {
      albumHighlightsItems.unshift(
        <AlbumHighlightsItems
          key={key}
          albumId={key}
          albumPhoto={this.state.albumPhotos[key]}
          albumTitle={this.state.albumTitles[key]}
          photoClicked={this.photoClicked}
        />
      );
    }, this);
    if (!this.props.isActive) {
      return null;
    }
    if (this.state.loading) {
      return (
        <div>
          <h3 className="g-mt-30">アルバム</h3>
          <div className="album-highlight-item">
            <div className="album-highlight" data-cat="1">
              <Loader isActive={this.state.loading} />
            </div>
            <span className="album-info" />
          </div>
        </div>
      );
    }
    return (
      <div className="albums">
        <h3>アルバム</h3>
        <section
          className="touch-wrap row scroll-bar album"
          style={{ padding: "1em" }}
        >
          <div className="touch" style={{ width: "100%" }}>
            {albumHighlightsItems}
          </div>
        </section>
        <ModalPhotoViewer
          isOpen={this.state.isModalOpen}
          onClose={this.closeModal}
          onChange={this.changePhoto}
          photoIndex={this.state.modalPhotoIndex}
          photoUrl={this.state.modalPhotoUrl}
          photoDir={this.state.modalPhotoDir}
          photoUploadedDate={this.state.modalPhotoUploadedDate}
        />
      </div>
    );
  },
});
